import { createTheme } from '@humans-sdk/core/theme';
import { enterpriseTheme } from '@humans-sdk/enterprise/theme';

import { Themes } from '@typings';

const theme = createTheme(enterpriseTheme, Themes.enterprise);

export default theme;
